/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('OtherWallCtrl', function($scope, $location, $routeParams, Walls, WallsService, identity) {
    angular.extend($scope, {
        params: {
            wall_name: $routeParams.wall_name
        }
    }
    );

    WallsService.fetchStaticTags()
    .then(tags => $scope.possible_tags = tags[$scope.params.wall_name]);

    identity
    .$promise
    .then(me => $scope.allow_reply = !['Etna - Infos', 'Etna - Événements'].includes($scope.params.wall_name) ||
        (['Etna - Infos', 'Etna - Événements'].includes($scope.params.wall_name) && Array.from(me.groups).includes('adm')));

    return $scope.disclaimer = (() => { switch ($scope.params.wall_name) {
        case 'Etna - Infos':                return 'Annonces officielles de l\'administration à l\'attention de tous.';
        case 'Etna - Café':                 return 'Vos sorties entre étudiants, propositions de WE ou autres.';
        case 'Etna - Jobs':                 return 'Petites annonces d\'emploi.';
        case 'Etna - Petites Annonces':     return 'Petites Annonces.';
        case 'Etna - Questions Techniques': return 'Questions techniques tout sujet, libre, indépendant des UV.';
        case 'Etna - Événements':           return `Annonces relatives aux événements de l\'école (hackathons extérieurs, \
meetup, événements de vie étudiante, opportunités offertes \
par des partenaires..)`;
        default: return '';
    } })();
});


